export default "__VITE_ASSET__BlU9c8P1__"